import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";

/** UI asli dari folder `traveling-web/frontend`, disalin ke `public/traveling-web/` */
function travelAppUrl() {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${base}/traveling-web/index.html`;
}

export default function TravelDemo() {
  const src = travelAppUrl();

  return (
    <div className="flex h-[100dvh] flex-col overflow-hidden bg-slate-950">
      <header className="z-10 flex shrink-0 flex-wrap items-center gap-3 border-b border-slate-800 bg-slate-950 px-4 py-2.5">
        <Link
          to="/#projects"
          className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Kembali ke portofolio
        </Link>
        <span className="hidden h-4 w-px bg-slate-700 sm:block" aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="text-[10px] uppercase tracking-wider text-slate-500">traveling-web</p>
          <p className="truncate text-sm font-semibold text-white">Asteria Voyage — tampilan asli</p>
        </div>
        <a
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 rounded-lg border border-slate-700 px-3 py-1.5 text-xs font-medium text-slate-200 hover:bg-slate-800"
        >
          <ExternalLink className="h-3.5 w-3.5" />
          Buka tab baru
        </a>
      </header>
      <iframe
        title="Asteria Voyage — traveling-web"
        src={src}
        className="h-full min-h-0 w-full flex-1 border-0 bg-[#081824]"
      />
    </div>
  );
}
